<!--suppress JSUnresolvedVariable, ES6CheckImport -->
<template>
  <div class="news-center bg-light py-5">
    <div class="container">
      <h3 class=" text-center text-warning font-weight-bold wow fadeInDown">
        新闻
        <img
          :src="titleImgUrl"
          alt="logo"
          width="50"
          height="50"
          class="rounded-circle mx-2"
        />
        中心
      </h3>
      <div class="text-center mb-4 text-secondary wow fadeInUp">
        —— {{ sectionSubTitle }} ——
      </div>
      <div class="row">
        <div
          class="col-12 col-lg-6 mb-3"
          v-for="(item, index) in newsList"
          :key="index"
        >
          <el-card
            class="card mb-3 p-3 border-0"
            :body-style="{ padding: '0px' }"
            shadow="hover"
          >
            <a @click="updateGameNewsViews(item.newsId)">
              <div class="row no-gutters">
                <div class="col-md-4">
                  <a href="#">
                    <img
                      :src="item.newsCover"
                      class="w-100 img-thumbnail"
                      alt="..."
                    />
                  </a>
                </div>
                <div class="col-md-8">
                  <div class="card-body p-0 pl-4">
                    <a href="#">
                      <span
                        class="badge badge-danger badge-pill text-white  p-1 px-2 my-2 my-sm-1"
                        v-if="item.newsTag === 1"
                        >hot</span
                      >
                      <span
                        class="badge badge-success badge-pill text-white  p-1 px-2 my-2 my-sm-1"
                        v-if="item.newsTag === 2"
                        >置顶</span
                      >
                      <span
                        class="badge badge-info badge-pill text-white  p-1 px-2 my-2 my-sm-1"
                        v-if="item.newsTag === 3"
                        >推荐</span
                      >
                    </a>
                    <h5 class="card-title">
                      <a href="#" class="text-dark">
                        {{ item.newsTitle }}
                      </a>
                    </h5>
                    <p class="card-text m-0">
                      <span class="text-danger">
                        <span class="text-muted">
                          浏览量：
                        </span>
                        {{ item.newsViews }}
                      </span>
                    </p>
                    <p class="card-text m-0">
                      <span class="text-info">
                        <span class="text-muted">
                          发布时间：
                        </span>
                        {{ item.publishTime }}
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </a>
          </el-card>
        </div>
      </div>
      <div class="text-center mt-4">
        <router-link
          to="/toNewsList"
          class="text-warning font-weight-bold find-more"
        >
          <img :src="moreImgUrl" alt="logo" width="40" class="rounded-circle" />
          查看更多
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { WOW } from "wowjs";

export default {
  name: "NewsCenter",
  data() {
    return {
      titleImgUrl: "",
      sectionSubTitle: "",
      moreImgUrl: "",
      logSys: 1,
      newsList: []
    };
  },
  mounted() {
    let options = { live: false };
    new WOW(options).init();
    this.isSystem();
    this.getNavById();
    this.getHomeNewsList();
  },
  methods: {
    isSystem() {
      if (navigator.userAgent.match("Android")) {
        this.logSys = 2;
      } else if (navigator.userAgent.match("iPhone")) {
        this.logSys = 3;
      } else if (navigator.userAgent.match("iPad")) {
        this.logSys = 3;
      } else {
        this.logSys = 1;
      }
    },
    getNavById() {
      this.axios
        .get("/navigation/getNavById/" + 3)
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.titleImgUrl = resp.data.data.titleImg;
            this.sectionSubTitle = resp.data.data.subTitle;
            this.moreImgUrl = resp.data.data.moreImgUrl;
          }
        })
        .catch();
    },
    getHomeNewsList() {
      this.axios
        .get("/news/getHomeNewsList")
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.newsList = resp.data.data;
          }
        })
        .catch();
    },
    updateGameNewsViews(newsId) {
      this.axios
        .put("/news/updateGameNewsViews/" + newsId, {
          logSys: this.logSys
        })
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.$router
              .push({ name: "NewsDetail", params: { newsId: newsId } })
              .catch();
          }
        })
        .catch();
    }
  }
};
</script>

<style scoped lang="scss">
.news-center {
  .container {
    .find-more {
      font-size: 18px;
    }
    @media only screen and (min-width: 576px) {
      .find-more {
        font-size: 14px;
      }
    }

    .row {
      div {
        .card:hover {
          box-shadow: 0 0 0.5rem rgba(255, 83, 10, 0.6);
          border-radius: 0;
        }

        .card-title {
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .news-summary {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
}
</style>
